// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiPagination-ul {
    justify-content: center;
}


.MuiPaginationItem-root.Mui-selected {
    background-color: #1976d2 !important;
    color: white !important;
}


.MuiPaginationItem-root:hover {
    background-color: rgba(25, 118, 210, 0.1) !important;
}


.MuiPaginationItem-root {
    color: #1976d2;
}

.AddKrabutton {
    width: 166px;
    height: 45px;
    border-radius: 3px;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 700 !important;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: center;
    background-color: #FE602F !important;
    color: white !important;
    margin-bottom: 15px;


}


.modalContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 800px;
    height: 80%;
    max-height: 400px;
    background-color: #fff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    padding: 24px;
    border-radius: 8px;
}


#kpi-details-modal {
    color: #0070E9;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
}


.labelkra {
    font-weight: 500;
    color: #0056b2;
    font-size: 0.875rem;
    margin-bottom: 8px;
    font-size: 16px;
}


.MuiTextField-root {
    margin-bottom: 16px;
}


.MuiOutlinedInput-root {
    & fieldset {
        border-color: #090909;
    }

    &:hover fieldset {
        border-color: #0070E9;
    }

    &.Mui-focused fieldset {
        border-color: #0070E9;
    }
}


.readOnlyInput .MuiOutlinedInput-root {
    background-color: #f5f5f5;
}


.buttonContainer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 20px;
}


.saveButton {
    background-color: #0070E9;
    color: #fff;

    &:hover {
        background-color: #005bb5;
    }
}


.cancelButton {
    color: #555;
    background-color: #f0f0f0;
    

    &:hover {
        background-color: #e0e0e0;
    }
}

.modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 800px;
    height: 80%;
    max-height: 350px;
    background-color: #fff;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
    padding: 24px;
    border-radius: 8px;
}







/* next */
.leavemanageHeading {
    font-family: "Inter";
    font-size: 18px;
    font-weight: 600;
    line-height: 21.78px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #0070E9;
    align-items: center;

}

.leavepage-1stgrid {

    display: flex;
    justify-content: end;

}

.dateInputforleave {
    background-color: #008A27 !important;
}

.dateInputforleave button {
    color: #fff !important;
}

.dateInputforleave input {
    padding: 9px !important;
    width: 100%;
    color: #fff !important;
}


.leavehistory {
    width: 100% !important;
    height: 39px !important;

    gap: 10px !important;

    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 19.36px !important;
    letter-spacing: 0.02em !important;
    text-align: left !important;
    /* padding: 10px, 20px, 10px, 20px !important; */
    color: #FE602F !important;
    text-transform: capitalize !important;
    border: 1px solid #FE602F !important
}

.MuiChartsLegend-mark {
    border-radius: 50% !important;
}


.Leave {
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19.36px !important;
    letter-spacing: 0.02em !important;
    text-align: left !important;

    color: #0070E9 !important
}

.nonleaveTab {
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19.36px !important;
    letter-spacing: 0.02em !important;
    text-align: left !important;
    color: #002C5D !important;


}

.css-1dk1qys-MuiTabs-indicator {
    color: #0070E9 !important
}


.rlreqlevreqButton {

    width: 100% !important;
    /* max-width: 155px !important; */
    height: 39px !important;
    padding: 10px 20px 10px 20px !important;
    gap: 10px !important;
    border-radius: 3px 0px 0px 0px !important;
    /* opacity: 0px !important; */
    background-color: #FE602F !important;
    color: white !important;
    text-transform: none !important;
    font-size: 15px !important;
    font-weight: 600 !important;

}


.rdp {
    width: 100% !important
}

.rdp-caption {
    width: 100% !important
}

.rdp-month .rdp-caption_start .rdp-caption_end {
    width: 100% !important
}





/* Modal container */
/* Modal container */
.yearend-modal-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 900px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  /* Modal header */
  .yearend-modal-content h2 {
    margin-bottom: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  
  /* Modal body container with flexbox */
  .yearend-modal-body {
    display: flex;
    flex-direction: row; /* Left-right layout */
    justify-content: space-between;
    width: 100%;
    gap: 30px;
  }
  
  /* Doughnut chart container */
  .yearend-chart-container {
    flex: 1 1;
    width: 100%;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Text fields container */
  .yearend-textfields {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 10px;
  }
  
  /* Input fields for ratings */
  .yearend-textfield {
    width: 100%;
  }
  
  /* Styling for readonly (Q1-Q4 ratings) fields */
  .yearend-textfield input[readonly] {
    background-color: #f5f5f5;
    color: #757575; /* Gray text color */
  }
  
  /* Editable Year End Rating text field */
  .yearend-textfield input {
    background-color: #ffffff;
  }
  
  /* Modal button container */
  .yearend-modal-buttons {
    display: flex;
    justify-content: flex-end !important;
    align-items: end;
    gap: 10px; /* Add space between buttons */
    padding: 10px; /* Optional: Adjust padding for layout */
  }
  
  .self-cancelButton {
    width: 97px !important;
    height: 39px !important;
    border-radius: 3px;
    border: 1px solid #FE602F !important;
    color: #FE602F !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    background-color: transparent; /* Default background */
    transition: all 0.3s ease; /* Smooth transition for hover */
  }
  
  .self-cancelButton:hover {
    background-color: #FE602F !important; /* Orange background on hover */
    color: #FFFFFF !important; /* White text on hover */
  }
  
  /* Save Button Styles with Hover */
  .self-saveButton {
    width: 80px !important;
    height: 39px !important;
    border-radius: 3px !important;
    background-color: #FE602F !important;
    color: #FFFFFF !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    border: none; /* Remove border for save button */
    transition: all 0.3s ease; /* Smooth transition for hover */
  }
  
  .self-saveButton:hover {
    background-color: #D94C1E !important; /* Slightly darker orange on hover */
    color: #FFFFFF !important; /* Keep text white */
  }

  /* General modal content */
  .report-modal-content {
    display: flex;
    flex-direction: column; /* Stack children vertically */
    justify-content: space-between; /* Space out children */
    padding: 20px;
    min-width: 80% !important;
    height: 82vh;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  
  /* Reusable Table container adjustments */
  .report-table-container {
    margin: 15px 0;
    max-width: 1000px !important;
    flex: 1 1; /* Allow the table to take available space */
    overflow-y: auto; /* Add scroll if content overflows */
  }
  
  
  /* Buttons section */
  
  
  /* Responsive adjustment */
  @media (max-width: 768px) {
    .report-modal-buttons {
      flex-direction: column;
      align-items: flex-end;
    }
  
    .report-cancelButton {
      width: 100%;
      text-align: center;
    }
  }


  `, "",{"version":3,"sources":["webpack://./src/views/panel/PerformanceManagement/HRView/HRview.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;;AAGA;IACI,oDAAoD;AACxD;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,oCAAoC;IACpC,uBAAuB;IACvB,mBAAmB;;;AAGvB;;;AAGA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,mBAAmB;AACvB;;;AAGA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;;IAEX;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,WAAW;IACX,yBAAyB;;;IAGzB;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,4CAA4C;IAC5C,aAAa;IACb,kBAAkB;AACtB;;;;;;;;AAQA,SAAS;AACT;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;;IAEI,aAAa;IACb,oBAAoB;;AAExB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;;IAEvB,oBAAoB;;IAEpB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;IAC3B,gDAAgD;IAChD,yBAAyB;IACzB,qCAAqC;IACrC;AACJ;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;;IAE3B;AACJ;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;IAC3B,yBAAyB;;;AAG7B;;AAEA;IACI;AACJ;;;AAGA;;IAEI,sBAAsB;IACtB,iCAAiC;IACjC,uBAAuB;IACvB,uCAAuC;IACvC,oBAAoB;IACpB,yCAAyC;IACzC,6BAA6B;IAC7B,oCAAoC;IACpC,uBAAuB;IACvB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;;AAE/B;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;;;;AAMA,oBAAoB;AACpB,oBAAoB;AACpB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,iBAAiB;EACjB;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA,sCAAsC;EACtC;IACE,aAAa;IACb,mBAAmB,EAAE,sBAAsB;IAC3C,8BAA8B;IAC9B,WAAW;IACX,SAAS;EACX;;EAEA,6BAA6B;EAC7B;IACE,SAAO;IACP,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;EACX;;EAEA,6BAA6B;EAC7B;IACE,WAAW;EACb;;EAEA,gDAAgD;EAChD;IACE,yBAAyB;IACzB,cAAc,EAAE,oBAAoB;EACtC;;EAEA,wCAAwC;EACxC;IACE,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,aAAa;IACb,oCAAoC;IACpC,gBAAgB;IAChB,SAAS,EAAE,8BAA8B;IACzC,aAAa,EAAE,wCAAwC;EACzD;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B;IAC7B,6BAA6B,EAAE,uBAAuB;IACtD,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA;IACE,oCAAoC,EAAE,+BAA+B;IACrE,yBAAyB,EAAE,wBAAwB;EACrD;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B;IAC7B,YAAY,EAAE,kCAAkC;IAChD,yBAAyB,EAAE,gCAAgC;EAC7D;;EAEA;IACE,oCAAoC,EAAE,oCAAoC;IAC1E,yBAAyB,EAAE,oBAAoB;EACjD;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,sBAAsB,EAAE,8BAA8B;IACtD,8BAA8B,EAAE,uBAAuB;IACvD,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;EAEA,yCAAyC;EACzC;IACE,cAAc;IACd,4BAA4B;IAC5B,SAAO,EAAE,4CAA4C;IACrD,gBAAgB,EAAE,oCAAoC;EACxD;;;EAGA,oBAAoB;;;EAGpB,0BAA0B;EAC1B;IACE;MACE,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;EACF","sourcesContent":[".MuiPagination-ul {\n    justify-content: center;\n}\n\n\n.MuiPaginationItem-root.Mui-selected {\n    background-color: #1976d2 !important;\n    color: white !important;\n}\n\n\n.MuiPaginationItem-root:hover {\n    background-color: rgba(25, 118, 210, 0.1) !important;\n}\n\n\n.MuiPaginationItem-root {\n    color: #1976d2;\n}\n\n.AddKrabutton {\n    width: 166px;\n    height: 45px;\n    border-radius: 3px;\n    font-family: \"Inter\";\n    font-size: 16px;\n    font-weight: 700 !important;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n    text-align: center;\n    background-color: #FE602F !important;\n    color: white !important;\n    margin-bottom: 15px;\n\n\n}\n\n\n.modalContainer {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80%;\n    max-width: 800px;\n    height: 80%;\n    max-height: 400px;\n    background-color: #fff;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n    padding: 24px;\n    border-radius: 8px;\n}\n\n\n#kpi-details-modal {\n    color: #0070E9;\n    font-size: 1.5rem;\n    font-weight: 600;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n\n.labelkra {\n    font-weight: 500;\n    color: #0056b2;\n    font-size: 0.875rem;\n    margin-bottom: 8px;\n    font-size: 16px;\n}\n\n\n.MuiTextField-root {\n    margin-bottom: 16px;\n}\n\n\n.MuiOutlinedInput-root {\n    & fieldset {\n        border-color: #090909;\n    }\n\n    &:hover fieldset {\n        border-color: #0070E9;\n    }\n\n    &.Mui-focused fieldset {\n        border-color: #0070E9;\n    }\n}\n\n\n.readOnlyInput .MuiOutlinedInput-root {\n    background-color: #f5f5f5;\n}\n\n\n.buttonContainer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 16px;\n    margin-top: 20px;\n}\n\n\n.saveButton {\n    background-color: #0070E9;\n    color: #fff;\n\n    &:hover {\n        background-color: #005bb5;\n    }\n}\n\n\n.cancelButton {\n    color: #555;\n    background-color: #f0f0f0;\n    \n\n    &:hover {\n        background-color: #e0e0e0;\n    }\n}\n\n.modal-content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80%;\n    max-width: 800px;\n    height: 80%;\n    max-height: 350px;\n    background-color: #fff;\n    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n    padding: 24px;\n    border-radius: 8px;\n}\n\n\n\n\n\n\n\n/* next */\n.leavemanageHeading {\n    font-family: \"Inter\";\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 21.78px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #0070E9;\n    align-items: center;\n\n}\n\n.leavepage-1stgrid {\n\n    display: flex;\n    justify-content: end;\n\n}\n\n.dateInputforleave {\n    background-color: #008A27 !important;\n}\n\n.dateInputforleave button {\n    color: #fff !important;\n}\n\n.dateInputforleave input {\n    padding: 9px !important;\n    width: 100%;\n    color: #fff !important;\n}\n\n\n.leavehistory {\n    width: 100% !important;\n    height: 39px !important;\n\n    gap: 10px !important;\n\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 700 !important;\n    line-height: 19.36px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left !important;\n    /* padding: 10px, 20px, 10px, 20px !important; */\n    color: #FE602F !important;\n    text-transform: capitalize !important;\n    border: 1px solid #FE602F !important\n}\n\n.MuiChartsLegend-mark {\n    border-radius: 50% !important;\n}\n\n\n.Leave {\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19.36px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left !important;\n\n    color: #0070E9 !important\n}\n\n.nonleaveTab {\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19.36px !important;\n    letter-spacing: 0.02em !important;\n    text-align: left !important;\n    color: #002C5D !important;\n\n\n}\n\n.css-1dk1qys-MuiTabs-indicator {\n    color: #0070E9 !important\n}\n\n\n.rlreqlevreqButton {\n\n    width: 100% !important;\n    /* max-width: 155px !important; */\n    height: 39px !important;\n    padding: 10px 20px 10px 20px !important;\n    gap: 10px !important;\n    border-radius: 3px 0px 0px 0px !important;\n    /* opacity: 0px !important; */\n    background-color: #FE602F !important;\n    color: white !important;\n    text-transform: none !important;\n    font-size: 15px !important;\n    font-weight: 600 !important;\n\n}\n\n\n.rdp {\n    width: 100% !important\n}\n\n.rdp-caption {\n    width: 100% !important\n}\n\n.rdp-month .rdp-caption_start .rdp-caption_end {\n    width: 100% !important\n}\n\n\n\n\n\n/* Modal container */\n/* Modal container */\n.yearend-modal-content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    width: 80%;\n    max-width: 900px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  /* Modal header */\n  .yearend-modal-content h2 {\n    margin-bottom: 20px;\n    font-size: 24px;\n    font-weight: bold;\n    color: #333;\n  }\n  \n  /* Modal body container with flexbox */\n  .yearend-modal-body {\n    display: flex;\n    flex-direction: row; /* Left-right layout */\n    justify-content: space-between;\n    width: 100%;\n    gap: 30px;\n  }\n  \n  /* Doughnut chart container */\n  .yearend-chart-container {\n    flex: 1;\n    width: 100%;\n    height: 300px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* Text fields container */\n  .yearend-textfields {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 10px;\n  }\n  \n  /* Input fields for ratings */\n  .yearend-textfield {\n    width: 100%;\n  }\n  \n  /* Styling for readonly (Q1-Q4 ratings) fields */\n  .yearend-textfield input[readonly] {\n    background-color: #f5f5f5;\n    color: #757575; /* Gray text color */\n  }\n  \n  /* Editable Year End Rating text field */\n  .yearend-textfield input {\n    background-color: #ffffff;\n  }\n  \n  /* Modal button container */\n  .yearend-modal-buttons {\n    display: flex;\n    justify-content: flex-end !important;\n    align-items: end;\n    gap: 10px; /* Add space between buttons */\n    padding: 10px; /* Optional: Adjust padding for layout */\n  }\n  \n  .self-cancelButton {\n    width: 97px !important;\n    height: 39px !important;\n    border-radius: 3px;\n    border: 1px solid #FE602F !important;\n    color: #FE602F !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center !important;\n    background-color: transparent; /* Default background */\n    transition: all 0.3s ease; /* Smooth transition for hover */\n  }\n  \n  .self-cancelButton:hover {\n    background-color: #FE602F !important; /* Orange background on hover */\n    color: #FFFFFF !important; /* White text on hover */\n  }\n  \n  /* Save Button Styles with Hover */\n  .self-saveButton {\n    width: 80px !important;\n    height: 39px !important;\n    border-radius: 3px !important;\n    background-color: #FE602F !important;\n    color: #FFFFFF !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center !important;\n    border: none; /* Remove border for save button */\n    transition: all 0.3s ease; /* Smooth transition for hover */\n  }\n  \n  .self-saveButton:hover {\n    background-color: #D94C1E !important; /* Slightly darker orange on hover */\n    color: #FFFFFF !important; /* Keep text white */\n  }\n\n  /* General modal content */\n  .report-modal-content {\n    display: flex;\n    flex-direction: column; /* Stack children vertically */\n    justify-content: space-between; /* Space out children */\n    padding: 20px;\n    min-width: 80% !important;\n    height: 82vh;\n    background: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  \n  /* Reusable Table container adjustments */\n  .report-table-container {\n    margin: 15px 0;\n    max-width: 1000px !important;\n    flex: 1; /* Allow the table to take available space */\n    overflow-y: auto; /* Add scroll if content overflows */\n  }\n  \n  \n  /* Buttons section */\n  \n  \n  /* Responsive adjustment */\n  @media (max-width: 768px) {\n    .report-modal-buttons {\n      flex-direction: column;\n      align-items: flex-end;\n    }\n  \n    .report-cancelButton {\n      width: 100%;\n      text-align: center;\n    }\n  }\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
